import { oneOf, bool } from '../../lib/viewState';

export const settingsViewCodec = {
  tab: oneOf('tab', ['general', 'security', 'data', 'automation', 'registers', 'invoicing'], 'general'),
  showAllTrash: bool('trash'),
};
